module.exports = __webpack_public_path__ + "img/petstairs39.e22d4767.jpg";